
namespace RioERP.Orders {
    export class TeacherPaymentsColumns {
        static columnsKey = 'Orders.TeacherPayments';
    }
}